import React from 'react';

import CheckoutForm from '../PaymentForm';
import InfoWidget from '../InfoWidget';

import './PaymentSection.scss';

/**
 * Component for displaying current 'cart' info and payment form
 *
 * @component
 * @example
 * return (
 *   <PaymentSection />
 * )
 */

const PaymentSection = () => {

    return (
        <div id="paymentSection" className="col-md-7 rounded py-3">

            <div className="widgets-container d-flex gap-2">

                <InfoWidget type="currentPlan" />

                <InfoWidget type="dueToday" />

            </div>

            <CheckoutForm />

        </div>
    );

}

export default PaymentSection;